// extracted by mini-css-extract-plugin
module.exports =  {"divider":"tK6W1Q3"};